const galleryContainer = document.querySelector('.gallery-container');
const galleryControlsContainer = document.querySelector('.gallery-controls');
const galleryControls = ['prev', 'next'];
const galleryItems = document.querySelectorAll('.gallery-item');

class Carousel {
    constructor(container, items, controls) {
        this.carouselContainer = container;
        this.carouselControls = controls;
        this.carouselArray = [...items];
    }

    // Update css classes for gallery
    updateGallery() {
        this.carouselArray.forEach(el => {
            el.classList.remove('gallery-item-1');
            el.classList.remove('gallery-item-2');
            el.classList.remove('gallery-item-3');
        });

        this.carouselArray.slice(0, 3).forEach((el, i) => {
            el.classList.add(`gallery-item-${i + 1}`);
        });
    }

    // Update the current order of the carouselArray and gallery
    setCurrentState(direction) {
        if (direction.className == 'gallery-controls-prev') {
            this.carouselArray.unshift(this.carouselArray.pop());
        } else {
            this.carouselArray.push(this.carouselArray.shift());
        }

        this.updateGallery();
    }

    // Construct the carousel controls
    setControls() {
        this.carouselControls.forEach(control => {
            galleryControlsContainer.appendChild(document.createElement('button')).className = `gallery-controls-${control}`;

            document.querySelector(`.gallery-controls-${control}`).innerHTML = control == 'prev'
                ? '<i class="bi bi-arrow-left-circle-fill h1 text-info"></i>'
                : '<i class="bi bi-arrow-right-circle-fill h1 text-info"></i>';
        });
    }

    // Add a click event listener to trigger setCurrentState method to rearrange carousel
    useControls() {
        const triggers = [...galleryControlsContainer.childNodes];

        triggers.forEach(control => {
            control.addEventListener('click', e => {
                e.preventDefault();

                if (control.className == 'gallery-controls-add') {
                    const newItem = document.createElement('img');
                    const latestItem = this.carouselArray.length;
                    const latestIndex = this.carouselArray.findIndex(item => item.getAttribute('data-index') == this.carouselArray.length) + 1;

                    // Assign the necessary properties for new gallery item
                    Object.assign(newItem, {
                        className: 'gallery-item',
                        src: `http://fakeimg.pl/300/?text=${this.carouselArray.length + 1}`
                    });
                    newItem.setAttribute('data-index', this.carouselArray.length + 1);

                    // Then add it to the carouselArray and update the gallery
                    this.carouselArray.splice(latestIndex, 0, newItem);
                    document.querySelector(`[data-index="${latestItem}"]`).after(newItem);
                    this.updateGallery();

                } else {
                    this.setCurrentState(control);
                }

            });
        });
    }
}

const exampleCarousel = new Carousel(galleryContainer, galleryItems, galleryControls);

exampleCarousel.setControls();
exampleCarousel.useControls();
